import { useContext, useEffect } from 'react';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { AddNewItemsAction } from '../../../lib/context/SmartSendContextModels';
import { RestorePanel } from '../panels/RestorePanel';
import { GenericEditProps } from './Edit';
import { EventSections } from '../../../lib/events/EventLogger';
import { Tagged } from '../../Tagged';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

export default function Restore(props: GenericEditProps) {
  const { getDeletedItems, bulkUpdateStatus } = useSmartSendApi();
  const ctx = useContext(SmartSendContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const { track } = useAnalytics();

  useEffect(() => {
    track({
      type: 'restore_item_loaded',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.RestoreItem])
      }
    });
  }, []);

  function onRestore(ids: string[]) {
    bulkUpdateStatus(ids, 'Active').then((r) => {
      if (r.success && r.result?.Items) {
        ctx.dispatch(new AddNewItemsAction(r.result.Items));
      }
      props.onClose();
    });
  }

  return (
    <P2GSidePanel
      open={true}
      onClose={props.onClose}
      anchor="right"
      title={t('RESTORE_ITEM_SIDEPANEL_TITLE', { defaultValue: 'Restore' })}
      width={'650px'}
    >
      <Tagged tag="panel-restore">
        <RestorePanel
          close={props.onClose}
          onRestore={onRestore}
          items={() =>
            getDeletedItems().then((r) => {
              return r.success ? r.result.Items : [];
            })
          }
        />
      </Tagged>
    </P2GSidePanel>
  );
}
